<template>
  <div>
    <section class="section has-background-white">
      <div class="container leadin">
        <div class="columns">
          <div class="column is-8 is-offset-2">
            <h2 class="title">Urlaubsgutscheine für Ihre Auszeit in Österreich</h2>
            <div class="content">
              <p>
                Ob Ski fahren im Frühling, Wellnessen & Entspannen oder Wandern im Sommer– genießen Sie Ihren Urlaub in einem Top-Hotel in Österreich. Profitieren Sie von tollen Preisvorteilen und gönnen Sie sich Ihr Reiseschnäppchen.
              </p>
              <p class="has-text-weight-bold">Clever & günstig reisen mit flexiblen Hotelgutscheinen, die drei Jahren gültig sind.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-offers has-background-white-ter">
      <div class="container">
        <div v-if="offers.length == 0 && traveldeal.length == 0">
          <NoOffer />
        </div>

        <div v-if="traveldeal.length > 0">
          <h2 class="title is-size-4 has-text-centered">Angebote enden in</h2>
          <CountdownTimer :endTime="campaignTimer" class="has-text-centered timer-lp mb-5" />

          <!-- bzw für normale suche haspromotion | Custom:suedtirol -->

          <div v-for="o in traveldeal" :key="o.id">
            <Deal :product="o" class="deal--schnaeppchen" v-bind:has-countdown="false" />
          </div>

          <div class="columns is-multiline is-variable is-5 mt-4">
            <div class="column is-half-tablet is-one-third-desktop is-flex" v-for="o in offers" :key="o.id">
              <OfferElement :product="o" class="offer--schnaeppchen" />
            </div>
          </div>

          <p class="has-text-centered has-text-weight-bold mt-5">Viele weitere Urlaubsgutscheine warten hier auf Sie!</p>
          <div class="has-text-centered mt-3">
            <b-button tag="router-link" to="/" type="is-dark">
              Zu allen Angeboten
            </b-button>
          </div>
        </div>
      </div>
    </section>

    <section class="section has-background-white is-hidden-mobile">
      <div class="container">
        <Advantages v-bind:size="'small'" class="mb-4" />
      </div>
    </section>
  </div>
</template>

<script>
import Advantages from '@/components/Advantages'
import CountdownTimer from '@/components/CountdownTimer'
import OfferElement from '@/components/OfferElement'
//import HeroBadge from '@/components/HeroBadge'
import OfferApi from '@/api/offer-api'
import Deal from '@/components/Deal'
import promotion from '@/common/promotion'

const NoOffer = () => import(/* webpackPrefetch: true , webpackChunkName: "nooffer" */ '@/components/NoOffer')

export default {
  name: 'Bargain',
  components: {
    Advantages,
    CountdownTimer,
    OfferElement,
    //HeroBadge,
    NoOffer,
    Deal,
  },
  data() {
    return {
      offers: [],
      traveldeal: [],
      promotionEndDate: '',
    }
  },
  computed: {
    campaignTimer: function() {
      //let endDate = new Date('2022-03-09 23:59') - new Date()
      let endDate = this.promotionEndDate - new Date()
      return endDate
    },
  },
  methods: {
    isTravelDeal(f) {
      return promotion.hasActivePromotion('TravelDeal', f)
    },
  },
  async mounted() {
    let offers = await OfferApi.getOffersWithCustomPromotion('deal')
    this.offers = offers.filter(item => !this.isTravelDeal(item))
    this.traveldeal = offers.filter(item => this.isTravelDeal(item))

    this.promotionEndDate = promotion.getEndDateForPromotionOnly('Custom:deal', this.$store.getters.promotions)

    //hide header only on this page + adapt leading spacing
    document.querySelector('.hero-about__wrapper').classList.add('is-hidden')
    document.querySelector('.leadin').classList.add('mt-5')
  },
  metaInfo() {
    return {
      title: 'Urlaubsgutscheine für Ihre Auszeit in Österreich',
      meta: [{name: 'description', content: 'Ob Ski fahren im Frühling, Wellnessen & Entspannen oder Wandern im Sommer– jetzt Reiseschnäppchen sichern!'}],
    }
  },
}
</script>

<style lang="scss"></style>
